Loalb-tab<script>
import Layout from "../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { userMethods } from "@/state/helpers";
import { userComputed } from "@/state/helpers";
import { hospitalMethods } from "@/state/helpers";
import { hospitalComputed } from "@/state/helpers";
import Locomo7 from "../../components/widgets/locomo-7.vue";
import HipScore from "../../components/widgets/hip-score.vue";
import Locomo25 from "../../components/widgets/locomo25.vue";

import Medical from "../../components/widgets/medical.vue";
import { filter } from "../../helpers/Vue-Filter";
import Loader from "../../components/widgets/loader.vue";

import pdfLocomo7 from "../pdf/locomo7.vue";
import pdfLocomo25 from "../pdf/locomo25.vue";
import pdfHipscore from "../pdf/hipscore.vue";
import pdfMedical from "../pdf/medical.vue";

import { mixin } from "../../helpers/Vue-Mixin";
import {getProfile} from "../../helpers/Auth";

export default {
  filters: {
    ...filter,
  },

  mixins: [mixin],

  page: {
    title: "詳細データ",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    Locomo7,
    HipScore,
    Locomo25,
    Medical,
    Loader,
    VueHtml2pdf: () => import(/* webpackPrefetch: true */ "vue-html2pdf"),
    pdfLocomo7,
    pdfLocomo25,
    pdfHipscore,
    pdfMedical,
  },

  data() {
    return {
      labelClass: [
        "badge-soft-danger",
        "badge-soft-success",
        "badge-soft-info",
      ],
      labelTitle: ["退会", "稼働中"],
      title: "Advanced Table",
      items: [
        {
          text: "会員一覧",
          href: "/#/admin/customers",
        },
        {
          text: " 詳細データ",
          active: true,
        },
      ],
      flavours: [],
      selected: [],
      allSelected: false,
      indeterminate: false,

      loaderLocomo7: false,
      loaderLocomo25: false,
      loaderHipscore: false,
      loaderMedical: false,
      loaderInfomation: false,
      role: getProfile().role.name,

      dataPDFLocomo7: [],
      dataPDFLocomo25: [],
      dataPDFHipscore: [],
      dataPDFMedical: [],
      timerProgress: 15000,
      progress: false,

      current_page: 1,
      dataWrapLoco7: [],
      dataWrapLoco25: [],
      dataWrapHipScore: [],
      dataWrapMedical: [],
    };
  },
  computed: {
    ...userComputed,
    ...hospitalComputed,

    rows() {
      return this.tableData.length;
    },
  },

  async created() {
    try {
      this.loaderLocomo7 = true;
      this.loaderInfomation = true;
      await this.userGetById(this.$route.params.id);
      await this.fetchUserHistories({
        role: this.role,
        survey_type: 1,
        uuid: this.$route.params.id,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      this.dataWrapLoco7 = JSON.parse(JSON.stringify(this.gUserHistories));
      setTimeout(
        function () {
          this.loaderLocomo7 = false;
          this.loaderInfomation = false;
        }.bind(this),
        1000
      );
    }
  },

  mounted() {},
  methods: {
    ...userMethods,
    ...hospitalMethods,

    hasStartedGeneration() {
      // eslint-disable-next-line no-console
      console.log("started");
    },

    hasGenerated(e) {
      // eslint-disable-next-line no-console
      console.log(e);
    },

    generateReport() {
      try {
        this.$refs.html2Pdf.generatePdf();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    onProgress(event) {
      if (!this.progress) {
        this.progress = true;
        this.progressBar(this.timerProgress);
      }
      if (event == 100) {
        this.progress = false;
        const loading = document.getElementsByClassName("swal2-confirm");
        if (loading.length > 0) {
          loading[0].click();
        }
      }
    },
    generatePDF() {
      this.$refs.html2PdfLocomo25.generatePdf();
    },

    exportPDFHipscores() {
      this.dataPDFHipscore = JSON.parse(JSON.stringify(this.gUserHistories));
      this.$refs.html2PdfHipscore.generatePdf();
    },

    exportPDFHipscore(arrList = []) {
      if (arrList && arrList.length > 0) {
        this.dataPDFHipscore = this.getData(arrList);
        this.$refs.html2PdfHipscore.generatePdf();
      }
    },

    exportPDFLocomos7() {
      this.dataPDFLocomo7 = JSON.parse(JSON.stringify(this.gUserHistories));
      this.$refs.html2Pdf.generatePdf();
    },

    exportPDFLocomo7(arrList = []) {
      if (arrList && arrList.length > 0) {
        this.dataPDFLocomo7 = this.getData(arrList);
        this.$refs.html2Pdf.generatePdf();
      }
    },

    async exportPDFLocomos25() {
      this.dataPDFLocomo25 = JSON.parse(JSON.stringify(this.gUserHistories));
      await this.$refs.html2PdfLocomo25.generatePdf();
    },

    exportPDFLocomo25(arrList = []) {
      if (arrList && arrList.length > 0) {
        this.dataPDFLocomo25 = this.getData(arrList);
        this.$refs.html2PdfLocomo25.generatePdf();
      }
    },

    exportPDFMedicals(value) {
      this.dataPDFMedical = JSON.parse(JSON.stringify(value));
      this.$refs.html2PdfMedical.generatePdf();
    },

    exportPDFMedical(arrList = []) {
      if (arrList && arrList.length > 0) {
        this.dataPDFMedical = arrList;
        this.$refs.html2PdfMedical.generatePdf();
      }
    },

    confirmDel() {
      try {
        this.confirm(
          {
            title: "",
            text: "この会員を削除しますか?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#8FC31F",
            cancelButtonColor: "#FF5858",
            confirmButtonText: "はい",
            cancelButtonText: "いいえ",
          },
          async (e) => {
            if (e.isConfirmed) {
              await this.del(this.$route.params.id);
              this.$router.go(-1);
              window.toastr.success("削除に完了しました");
            }
          }
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    getData(uuids) {
      const data = [];
      for (const item of this.gUserHistories) {
        if (uuids.includes(item.uuid)) {
          data.push(item);
        }
      }

      return data;
    },

    async loadMoreLoco7() {
      try {
        await this.fetchUserHistories({
          role: this.role,
          survey_type: 1,
          uuid: this.$route.params.id,
          page: this.current_page + 1,
        }).then((e) => {
          if (e.status == 200) {
            if (this.dataWrapLoco7.length < e.data.meta.total) {
              this.dataWrapLoco7 = this.dataWrapLoco7.concat(e.data.data);
            }
          }
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    async loadMoreLoco25() {
      try {
        await this.fetchUserHistories({
          role: this.role,
          survey_type: 2,
          uuid: this.$route.params.id,
          page: this.current_page + 1,
        }).then((e) => {
          if (e.status == 200) {
            if (this.dataWrapLoco25.length < e.data.meta.total) {
              this.dataWrapLoco25 = this.dataWrapLoco25.concat(e.data.data);
            }
          }
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    async loadMoreHipScore() {
      try {
        await this.fetchUserHistories({
          role: this.role,
          survey_type: 3,
          uuid: this.$route.params.id,
          page: this.current_page + 1,
        }).then((e) => {
          if (e.status == 200) {
            if (this.dataWrapHipScore.length < e.data.meta.total) {
              this.dataWrapHipScore = this.dataWrapHipScore.concat(e.data.data);
            }
          }
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    async loadMoreMedical() {
      try {
        const userInFor = await api.userGetById(this.$route.params.id)
        await this.getMedicalHistory({
          role: this.role,
          uuid: userInFor.data.medical_id,
          page: this.current_page + 1,
        }).then((e) => {
          if (e.status == 200) {
            if (this.dataWrapMedical.length < e.data.meta.total) {
              this.dataWrapMedical = this.dataWrapMedical.concat(e.data.data);
            }
          }
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    async clickTabs(value) {
      switch (value) {
        case "LCM7":
          try {
            this.loaderLocomo7 = true;
            await this.fetchUserHistories({
              role: this.role,
              survey_type: 1,
              uuid: this.$route.params.id,
            });
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
          } finally {
            setTimeout(
              function () {
                this.loaderLocomo7 = false;
              }.bind(this),
              1000
            );
          }
          break;
        case "LCM25":
          try {
            this.loaderLocomo25 = true;
            await this.fetchUserHistories({
              role: this.role,
              survey_type: 2,
              uuid: this.$route.params.id,
            }).then((e) => {
              if (e.status == 200) {
                this.dataWrapLoco25 = JSON.parse(
                  JSON.stringify(this.gUserHistories)
                );
              }
            });
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
          } finally {
            setTimeout(
              function () {
                this.loaderLocomo25 = false;
              }.bind(this),
              1000
            );
          }
          break;
        case "HIPSCORE":
          try {
            this.loaderHipscore = true;

            await this.fetchUserHistories({
              role: this.role,
              survey_type: 3,
              uuid: this.$route.params.id,
            }).then((e) => {
              if (e.status == 200) {
                this.dataWrapHipScore = JSON.parse(
                  JSON.stringify(this.gUserHistories)
                );
              }
            });
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
          } finally {
            setTimeout(
              function () {
                this.loaderHipscore = false;
              }.bind(this),
              1000
            );
          }
          break;
        case "MEDICAL":
          try {
            this.loaderMedical = true;
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
          } finally {
            setTimeout(
              function () {
                this.loaderMedical = false;
              }.bind(this),
              1000
            );
          }
          break;

        case "EXCFEE":
          try {
            this.loaderMedical = true;
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
          } finally {
            setTimeout(
              function () {
                this.loaderMedical = false;
              }.bind(this),
              1000
            );
          }

          break;

        case "EXCFREE":
          try {
            this.loaderMedical = true;
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
          } finally {
            setTimeout(
              function () {
                this.loaderMedical = false;
              }.bind(this),
              1000
            );
          }
          break;

        default:
          break;
      }
    },
  },

  watch: {
    selected(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.flavours.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<style scoped>
#parent {
  position: relative;
  z-index: 0;
}

#child {
  width: 100%;
  height: 100%;

  position: absolute;
  top: 50%;
  left: 50%;
  margin: -20px 0 0 -25px;
  font-size: 25px;
  z-index: 1;
}
</style>

<template>
  <Layout>
    <PageHeader
      :items="items"
      :showDel="gUserById.is_used === 0"
      titleButtonDel="削除"
      @showModalDel="confirmDel()"
    />
    <div class="card">
      <Loader theme="plus" :loading="loaderInfomation">
        <div class="col-12 px-4 pt-4" style="padding-bottom: 1rem !important;">
          <div class="d-flex justify-content-between">
            <h5 class="text-table">
              {{ $t("menuitems.hospital.memberProfile") }}
            </h5>
            <div class="d-flex" style="align-items: center">
              <label
                  class="w-lg badge rounded-pill status-label m-0"
                  :class="labelClass[gUserById.is_used]"
              >{{ labelTitle[gUserById.is_used] }}</label
              >
              <div v-if="gUserById.is_used === 0">
                <button class="btn-remove" @click="confirmDel()" title="削除">
                  <i
                      class="bx bx-trash text-white bg-danger p-1"
                      style="border-radius: 50%; cursor: pointer"
                  ></i>
                </button>
              </div>
            </div>
          </div>
          <hr class="mb-1" />
          <div class="row gap-info">
            <div class="col-md-2">
              <div class="mt-3">
                <label class="text-labelInfo"> 会員ID</label>
                <h6 class="text-table">
                  {{ gUserById ? gUserById.patient_id : "" }}
                </h6>
              </div>
            </div>

            <div class="col-md-2">
              <div class="mt-3">
                <label class="text-labelInfo"> 名前 </label>
                <h6 class="text-table">
                  <b>{{
                      gUserById.information ? gUserById.information.fullname : ""
                    }}</b>
                </h6>
              </div>
            </div>

            <div class="col-md-2">
              <div class="mt-3">
                <label class="text-labelInfo"> 年齢 </label>
                <h6 class="text-table">
                  <b>{{
                      gUserById.information ? gUserById.information.age : ""
                    }}</b>
                </h6>
              </div>
            </div>

            <div class="col-md-2">
              <div class="mt-3">
                <label class="text-labelInfo"> 登録日 </label>
                <h6 class="text-table">
                  <b>{{ gUserById.created_at | fomatDate2 }}</b>
                </h6>
              </div>
            </div>

            <div class="col-md-2">
              <div class="mt-3">
                <label class="text-labelInfo"> 都道府県 </label>
                <h6 class="text-table">
                  <b>{{
                    gUserById.information ? gUserById.information.city : ""
                  }}</b>
                </h6>
              </div>
            </div>
          </div>

          <div class="row gap-info">
            <div class="col-md-2">
              <div class="mt-3">
                <label class="text-labelInfo"> パスワード </label>
                <div class="text-table">
                  <b>{{ gUserById ? gUserById.password : "" }}</b>
                </div>
              </div>
            </div>

            <div class="col-md-2">
              <div class="mt-3">
                <label class="text-labelInfo"> 性別 </label>
                <h6 class="text-table">
                  {{
                    gUserById.information && gUserById.information.sex === 0
                        ? "女性"
                        : gUserById.information && gUserById.information.sex === 1
                        ? "男性"
                        : "無回答"
                  }}
                </h6>
              </div>
            </div>

            <div class="col-md-2">
              <div class="mt-3">
                <label class="text-labelInfo"> 生年月日 </label>
                <h6 class="text-table">
                  <b>{{
                    gUserById.information ? gUserById.information.birthday : ""
                  }}</b>
                </h6>
              </div>
            </div>

            <div class="col-md-2">
              <div class="mt-3">
                <label class="text-labelInfo"> 最終更新 </label>
                <h6 class="text-table">
                  <b>{{ gUserById.updated_at | fomatDate2 }}</b>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </Loader>
    </div>
    <div class="row">
      <div class="col-lg">
        <div class="card">
          <div class="card-body">
            <b-tabs
              active-nav-item-class="font-weight-bold text-uppercase text-lgy"
              active-tab-class="font-weight-bold text-muted p-md-2 mt-1"
              content-class="text-muted"
            >
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    $t("menuitems.hospital.judgmentResult")
                  }}</span>
                </template>
                <div>
                  <b-tabs
                    active-nav-item-class="font-weight-bold text-uppercase text-white btn-lyg"
                    active-tab-class="font-weight-bold text-muted p-md-3"
                    class="p-0"
                    pills
                    card
                  >
                    <b-tab
                      lazy
                      :title="$t('menuitems.hospital.loco7')"
                      active
                      @click="clickTabs('LCM7')"
                    >
                      <Loader theme="plus" :loading="loaderLocomo7">
                        <VueHtml2pdf
                          :show-layout="false"
                          :float-layout="true"
                          :enable-download="true"
                          :preview-modal="false"
                          :paginate-elements-by-height="1400"
                          :html-to-pdf-options="{
                            margin: 0,
                            filename: `7つのロコチェック_${
                              gUserById ? gUserById.patient_id : ''
                            }`,

                            image: {
                              type: 'jpeg',
                              quality: 0.98,
                            },

                            enableLinks: false,

                            html2canvas: {
                              scale: 1,
                              useCORS: true,
                            },

                            jsPDF: {
                              unit: 'in',
                              format: 'a4',
                              orientation: 'portrait',
                            },
                          }"
                          :manual-pagination="true"
                          pdf-format="a4"
                          pdf-orientation="portrait"
                          pdf-content-width="100%"
                          @progress="onProgress($event)"
                          @hasStartedGeneration="hasStartedGeneration()"
                          @hasGenerated="hasGenerated($event)"
                          ref="html2Pdf"
                        >
                          <section slot="pdf-content">
                            <template>
                              <pdfLocomo7
                                :infoPDF="gUserById"
                                :locomo7="dataPDFLocomo7"
                              />
                            </template>
                          </section>
                        </VueHtml2pdf>
                        <Locomo7
                          @pdfLocomos7="exportPDFLocomos7"
                          @pdfLocomo7="exportPDFLocomo7"
                          @loadMoreLocomo7="loadMoreLoco7()"
                          :locomo7="dataWrapLoco7"
                          :pagination="gPaginationUserHistory"
                        />
                      </Loader>
                    </b-tab>
                    <b-tab
                      lazy
                      :title="$t('menuitems.hospital.loco25')"
                      @click="clickTabs('LCM25')"
                    >
                      <Loader theme="plus" :loading="loaderLocomo25">
                        <VueHtml2pdf
                          :show-layout="false"
                          :float-layout="true"
                          :enable-download="true"
                          :preview-modal="false"
                          :paginate-elements-by-height="1200"
                          :pdf-quality="2"
                          :manual-pagination="true"
                          :html-to-pdf-options="{
                            margin: [15, 0, 19, 0],
                            filename: `ロコモ25_${
                              gUserById ? gUserById.patient_id : ''
                            }`,
                          }"
                          pdf-format="a4"
                          pdf-orientation="portrait"
                          pdf-content-width="100%"
                          @progress="onProgress($event)"
                          @hasStartedGeneration="hasStartedGeneration()"
                          @hasGenerated="hasGenerated($event)"
                          ref="html2PdfLocomo25"
                        >
                          <section slot="pdf-content">
                            <template>
                              <pdfLocomo25
                                :infoPDF="gUserById"
                                :locomo25="dataPDFLocomo25"
                              />
                            </template>
                          </section>
                        </VueHtml2pdf>
                        <Locomo25
                          @pdfLocomos25="exportPDFLocomos25"
                          @pdfLocomo25="exportPDFLocomo25"
                          @loadMoreLocomo25="loadMoreLoco25()"
                          :locomo25="dataWrapLoco25"
                          :pagination="gPaginationUserHistory"
                        />
                      </Loader>
                    </b-tab>
                    <b-tab
                      lazy
                      :title="$t('menuitems.hospital.hipscore')"
                      @click="clickTabs('HIPSCORE')"
                    >
                      <VueHtml2pdf
                        :show-layout="false"
                        :float-layout="true"
                        :enable-download="true"
                        :preview-modal="false"
                        :paginate-elements-by-height="1200"
                        :html-to-pdf-options="{
                          margin: 10,
                          filename: `股関節スコア_${
                            gUserById ? gUserById.patient_id : ''
                          }`,
                        }"
                        :pdf-quality="2"
                        :manual-pagination="true"
                        pdf-format="a4"
                        pdf-orientation="portrait"
                        pdf-content-width="100%"
                        @progress="onProgress($event)"
                        @hasStartedGeneration="hasStartedGeneration()"
                        @hasGenerated="hasGenerated($event)"
                        ref="html2PdfHipscore"
                      >
                        <section slot="pdf-content">
                          <template>
                            <pdfHipscore
                              :infoPDF="gUserById"
                              :hipscore="dataPDFHipscore"
                            />
                          </template>
                        </section>
                      </VueHtml2pdf>

                      <Loader theme="plus" :loading="loaderHipscore">
                        <HipScore
                          @exportPDFHipcores="exportPDFHipscores"
                          @exportPDFHipscore="exportPDFHipscore"
                          :hipscore="dataWrapHipScore"
                          @loadMoreHipscore="loadMoreHipScore()"
                          :pagination="gPaginationUserHistory"
                        />
                      </Loader>
                    </b-tab>
                    <b-tab
                      lazy
                      :title="$t('menuitems.hospital.medicalExamination')"
                      @click="clickTabs('MEDICAL')"
                    >
                      <VueHtml2pdf
                        :show-layout="false"
                        :float-layout="true"
                        :enable-download="true"
                        :preview-modal="false"
                        :paginate-elements-by-height="1200"
                        :html-to-pdf-options="{
                          margin: 10,
                          filename: `身体状態_${
                            gUserById ? gUserById.patient_id : ''
                          }`,
                        }"
                        :pdf-quality="2"
                        :manual-pagination="true"
                        pdf-format="a4"
                        pdf-orientation="portrait"
                        pdf-content-width="100%"
                        @progress="onProgress($event)"
                        @hasStartedGeneration="hasStartedGeneration()"
                        @hasGenerated="hasGenerated($event)"
                        ref="html2PdfMedical"
                      >
                        <section slot="pdf-content">
                          <template>
                            <pdfMedical
                              :infoPDF="gUserById"
                              :dataPdf="dataPDFMedical"
                            />
                          </template>
                        </section>
                      </VueHtml2pdf>

                      <Loader theme="plus" :loading="loaderMedical">
                        <Medical
                          @exportPDFMedicals="exportPDFMedicals"
                          @exportPDFMedical="exportPDFMedical"
                          :pagination="gPaginationMedical"
                          @loadMoreMedical="loadMoreMedical()"
                        />
                      </Loader>
                    </b-tab>
                  </b-tabs>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block text-muted"
                    >運動履歴</span
                  >
                </template>
                <div>
                  <b-tabs
                    active-nav-item-class="font-weight-bold text-uppercase text-white btn-lyg"
                    active-tab-class="font-weight-bold text-muted p-md-3"
                    class="p-0"
                    pills
                    card
                  >
                  </b-tabs>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
* {
  font-family: "Noto Sans JP";
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}
.gap-info {
  gap: 3rem !important;
  @media (max-width: 1440px) {
    gap: 1rem !important;
  }
}

.text-table {
  color: #404040;
  font-weight: 700;
  font-size: 16px;
}

.text-labelInfo {
  color: #828282;
  font-weight: 400;
  font-size: 14px;
}

.status-label {
  border-radius: 100px !important;
  text-align: center;
  padding: 5px;
  width: 144px;
  height: 36px;
  font-size: 14px;
  line-height: 26px;
}
.btn-remove {
  background: none !important;
  color: red !important;
  border: none;
}
.bx-trash {
  width: 30px;
  border-radius: 50%;
  cursor: pointer;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .footer {
   position: fixed !important;
}

.bx-trash:hover {
  background: red;
  transform: scale(1.1);
}
</style>
